import * as images from "./images";
const destinations = [
  {
    id: 1,
    title: "Краснодар",
    image: images.krasnodar,
    price: "1 212",
    date: "18 марта",
    country: "Россия",
    flag: images.flagRu
  },
  {
    id: 2,
    title: "Сочи (Адлер)",
    image: images.sochi,
    price: "1 334",
    date: "27 марта",
    country: "Россия",
    flag: images.flagRu
  },
  {
    id: 3,
    title: "Санкт-Петербург",
    image: images.spb,
    price: "1 508",
    date: "19 февраля",
    country: "Россия",
    flag: images.flagRu
  },
  {
    id: 4,
    title: "Минеральные Воды",
    image: images.min,
    price: "2 074",
    date: "13 марта",
    country: "Россия",
    flag: images.flagRu
  },
  {
    id: 5,
    title: "Симферополь (Крым)",
    image: images.simf,
    price: "2 407",
    date: "13 марта",
    country: "Россия",
    flag: images.flagRu
  },
  {
    id: 6,
    title: "Барселона",
    image: images.barca,
    price: "4 272",
    date: "24 марта",
    country: "Испания",
    flag: images.flagEsp
  }
];
export default destinations;
